module.exports = __webpack_public_path__ + "img/check.7e94791f.png";